var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJcbImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.272,
    height: 17.466,
    viewBox: "0 0 23.272 17.466",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.575,
    y1: 0.501,
    x2: 2.324,
    y2: 0.501,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#00873f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40a737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5cb531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.002,
    y1: 0.5,
    x2: 1.003,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.628,
    y1: 0.499,
    x2: 2.537,
    y2: 0.499,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.002,
    y1: 0.5,
    x2: 1.018,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f286f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#004e94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#0066b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006fbc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.006,
    y1: 0.499,
    x2: 0.981,
    y2: 0.499,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c2c2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#be1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#dc0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e60039"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "JCB_-_img",
    "data-name": "JCB - img",
    transform: "translate(-14.083 -13.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38545",
    "data-name": "Path 38545",
    d: "M185.584,103.559h1.679c.048,0,.16-.016.208-.016a.749.749,0,0,0,.592-.752.776.776,0,0,0-.592-.752.843.843,0,0,0-.208-.016h-1.679Z",
    transform: "translate(-153.971 -79.655)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38546",
    "data-name": "Path 38546",
    d: "M174.428,13.3a2.911,2.911,0,0,0-2.911,2.911v3.023h4.111a1.644,1.644,0,0,1,.288.016c.928.048,1.615.528,1.615,1.36a1.36,1.36,0,0,1-1.328,1.328v.032c.944.064,1.663.592,1.663,1.408,0,.88-.8,1.455-1.855,1.455H171.5V30.75h4.27a2.911,2.911,0,0,0,2.911-2.911V13.3Z",
    transform: "translate(-141.328 0)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38547",
    "data-name": "Path 38547",
    d: "M187.855,80.508a.68.68,0,0,0-.592-.688c-.032,0-.112-.016-.16-.016h-1.52v1.408h1.52a.446.446,0,0,0,.16-.016.68.68,0,0,0,.592-.688Z",
    transform: "translate(-153.971 -59.706)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38548",
    "data-name": "Path 38548",
    d: "M17.01,13.3A2.911,2.911,0,0,0,14.1,16.212v7.181a5.756,5.756,0,0,0,2.511.656,1.393,1.393,0,0,0,1.551-1.439V19.219h2.5v3.375c0,1.312-.816,2.383-3.583,2.383a12.278,12.278,0,0,1-2.991-.368v6.126h4.27a2.911,2.911,0,0,0,2.911-2.911V13.3Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38549",
    "data-name": "Path 38549",
    d: "M95.86,13.3a2.911,2.911,0,0,0-2.911,2.911v3.807c.736-.624,2.015-1.024,4.079-.928a12.977,12.977,0,0,1,2.287.352v1.232a5.536,5.536,0,0,0-2.207-.64c-1.567-.112-2.511.656-2.511,2,0,1.359.944,2.127,2.511,2a5.808,5.808,0,0,0,2.207-.64v1.232a12.673,12.673,0,0,1-2.287.352c-2.063.1-3.343-.3-4.079-.928v6.718h4.271a2.911,2.911,0,0,0,2.911-2.911V13.3Z",
    transform: "translate(-70.804 0)",
    fill: "url(#linear-gradient-5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcbImg);
export default __webpack_public_path__ + "static/media/JCB - img.a96cb7da.svg";
export { ForwardRef as ReactComponent };